export enum SystemNotificationsStatusEnum {
    active = 'ACTIVE',
    pending = 'PENDING',
    past = 'STATUS'
}
